export default __webpack_public_path__ + "static/media/podcast.e6f0b893.mp4";